export const dataStoreSelector = state => state.data;
export const aggregationStoreSelector = state => state.aggregations;
export const loginStoreSelector = state => state.login;
export const entityStoreSelector = state => state.entities;
export const selectionStoreSelector = state => state.selections;
export const indicesStoreSelector = state => state.indices;
export const loadingStoreSelector = state => state.loading;
export const uiStoreSelector = state => state.ui;
